var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-head"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}}),_c('div',{staticClass:"head-slot"},[_vm._t("default")],2),_vm._t("head-slot")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }